import get from "lodash/get";
import React, {Component} from "react";
import compose from "lodash/flowRight";
import {graphql} from "@apollo/client/react/hoc";
import withSourceTracking from "../../SourceTracking/withSourceTracking/withSourceTracking";
import withAuth from "../../Auth/withAuth/withAuth";
import GetUniversityQuery from "../../University/queries/GetUniversityQuery";

export function withOpenInJigglypuffComponent(WrappedComponent) {
    class OpenInJigglypuffComponent extends Component {
        getJigglypuffUrl = (path) => {
            if (this.props.university) {
                if (get(this.props, "university.widgetUrl", "") !== "") {
                    return `${this.props.university.widgetUrl}?unibuddy=${path}`;
                }

                return `/embed/${this.props.university.slug}/colour/${this.props.university.colour}/${path}`;
            }

            return "";
        };

        openInJigglypuff = (path) => {
            window.open(
                this.props.sourceTracking.redirectWithSourceTracking(this.getJigglypuffUrl(path)),
                "_blank",
            );
        };

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    getJigglypuffUrl={this.getJigglypuffUrl}
                    openInJigglypuff={this.openInJigglypuff}
                />
            );
        }
    }

    return OpenInJigglypuffComponent;
}

function enhancedWithOpenInJigglypuff(WrappedComponent) {
    const universityQueryOptions = {
        name: "universityQuery",
        options(props) {
            return {
                variables: {
                    slug: props.match.params.universitySlug,
                },
            };
        },
        props({universityQuery: {university}}) {
            return {
                university,
            };
        },
    };

    return compose(
        withAuth,
        withSourceTracking,
        graphql(GetUniversityQuery, universityQueryOptions),
    )(withOpenInJigglypuffComponent(WrappedComponent));
}

export default enhancedWithOpenInJigglypuff;
